var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-detection-package-update',{staticClass:"pt-detection-package-update__page"})}
var staticRenderFns = []

export { render, staticRenderFns }